export const BROWSER_PREVIEW_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'webp', 'mp4', 'gif', 'mov'];
